"use client";

import type { ImageLoaderProps } from "next/image";
import { MEDIA_IMAGE_WIDTHS } from "./processing-policy";

// Only the processor's versioned width ladder has predictable sibling URLs.
const DERIVATIVE =
  /^(https?:\/\/[^/]+\/[a-z]+\/[^/]+\/[a-z0-9_-]+-)(320|640|1080|1600)(\/[a-f0-9]{32}\.webp)(?:[?#].*)?$/i;
export function isResponsiveMediaUrl(src: unknown): src is string {
  return typeof src === "string" && DERIVATIVE.test(src);
}
export default function mediaImageLoader({ src, width }: ImageLoaderProps) {
  const match = src.match(DERIVATIVE);
  if (!match) return src;
  const ceiling = Number(match[2]);
  const selected =
    MEDIA_IMAGE_WIDTHS.find((size) => size >= width && size <= ceiling) ??
    ceiling;
  return `${match[1]}${selected}${match[3]}`;
}
